import React from 'react'
import { Grid } from '@material-ui/core/'
import useStyles from './InputSectionLayout.style'

/**
 * A layout component to ensure that the left side input sections on the checkout page all have the same widths
 * @param {object} props
 * @param {React.ReactNode} props.left
 * @param {React.ReactNode} [props.right]
 */
const InputSectionLayout = (props) => {
  const classes = useStyles()
  const { left, right } = props
  return (
    <Grid container alignItems='center'>
      <Grid item className={classes.leftItem}>
        {left}
      </Grid>
      <Grid item xs={3}>
        {right}
      </Grid>
    </Grid>
  )
}

export default InputSectionLayout
